import { useCurrentUser } from "hooks/use-current-user"
import { isStaticFeatureEnabled } from "hooks/use-feature"

/**
 * Builds the {@link import("./types").CommandContext} passed to every provider.
 *
 * `pathname`/`search` are read straight from `window.location` so they're
 * correct on both Inertia pages and traditional Rails views. The palette
 * re-renders whenever it opens, so the URL is current at the moment it matters
 * (when the user invokes it).
 *
 * @returns {import("./types").CommandContext}
 */
export function useCommandPaletteContext() {
  const user = useCurrentUser()

  return {
    pathname: window.location.pathname,
    search: window.location.search,
    user,
    isFeatureEnabled: isStaticFeatureEnabled
  }
}
